// Chicago neighborhoods (comprehensive list)
export const NEIGHBORHOODS = [
  'Albany Park',
  'Andersonville',
  'Archer Heights',
  'Armour Square',
  'Ashburn',
  'Auburn Gresham',
  'Austin',
  'Avalon Park',
  'Avondale',
  'Back of the Yards',
  'Beverly',
  'Bowmanville',
  'Boystown',
  'Bridgeport',
  'Brighton Park',
  'Bronzeville',
  'Bucktown',
  'Buena Park',
  'Burnside',
  'Calumet Heights',
  'Chatham',
  'Chicago Lawn',
  'Chinatown',
  'Clearing',
  'Douglas',
  'Dunning',
  'East Garfield Park',
  'East Side',
  'Edgebrook',
  'Edgewater',
  'Edison Park',
  'Englewood',
  'Forest Glen',
  'Fulton Market',
  'Gage Park',
  'Galewood',
  'Garfield Ridge',
  'Gold Coast',
  'Goose Island',
  'Grand Boulevard',
  'Greater Grand Crossing',
  'Hegewisch',
  'Hermosa',
  'Humboldt Park',
  'Hyde Park',
  'Irving Park',
  'Jefferson Park',
  'Kenwood',
  'Lakeview',
  'Lincoln Park',
  'Lincoln Square',
  'Little Italy',
  'Little Village',
  'Logan Square',
  'Loop',
  'Lower West Side',
  'Magnificent Mile',
  'Marquette Park',
  'McKinley Park',
  'Montclare',
  'Morgan Park',
  'Mount Greenwood',
  'Near North Side',
  'Near South Side',
  'Near West Side',
  'New City',
  'Noble Square',
  'North Center',
  'North Lawndale',
  'North Park',
  'Norwood Park',
  'Oakland',
  'Old Town',
  'Pilsen',
  'Portage Park',
  'Printer\'s Row',
  'Pullman',
  'Ravenswood',
  'River North',
  'River West',
  'Rogers Park',
  'Roscoe Village',
  'Sauganash',
  'South Chicago',
  'South Deering',
  'South Loop',
  'South Lawndale',
  'South Shore',
  'Streeterville',
  'Ukrainian Village',
  'Uptown',
  'Washington Heights',
  'Washington Park',
  'West Elsdon',
  'West Englewood',
  'West Garfield Park',
  'West Lawn',
  'West Loop',
  'West Pullman',
  'West Ridge',
  'West Town',
  'Wicker Park',
  'Woodlawn',
  'Wrigleyville'
];

// Seed bars data - 15 famous Chicago dive bars
export const SEED_BARS = [
  {
    id: 'bar_1',
    name: 'The Old Town Ale House',
    address: '219 W North Ave',
    neighborhood: 'Old Town',
    lat: 41.9112,
    lng: -87.6351,
    description: 'Legendary dive with politically-charged artwork and a famous painting of Sarah Palin. Cash only, no pretense.',
    attributes: {
      poolTable: false,
      darts: true,
      cashOnly: true,
      jukebox: true,
      outdoorSeating: false,
      liveMusic: false,
      happyHour: false,
      touchTunes: false,
      triviaNights: false,
      euchre: false,
      oldStyleSign: true
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_2',
    name: "Simon's Tavern",
    address: '5210 N Clark St',
    neighborhood: 'Andersonville',
    lat: 41.9761,
    lng: -87.6684,
    description: 'Swedish-themed vintage bar famous for their glögg. Been serving since 1934.',
    attributes: {
      poolTable: false,
      darts: false,
      cashOnly: false,
      jukebox: true,
      outdoorSeating: true,
      liveMusic: true,
      happyHour: true
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_3',
    name: "Carol's Pub",
    address: '4659 N Clark St',
    neighborhood: 'Uptown',
    lat: 41.9657,
    lng: -87.6684,
    description: 'Honky-tonk roadhouse in the heart of Chicago. Live country music and cheap beer.',
    attributes: {
      poolTable: true,
      darts: true,
      cashOnly: true,
      jukebox: false,
      outdoorSeating: false,
      liveMusic: true,
      happyHour: false
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_4',
    name: "Delilah's",
    address: '2771 N Lincoln Ave',
    neighborhood: 'Lincoln Park',
    lat: 41.9309,
    lng: -87.6671,
    description: 'Punk rock whiskey bar with hundreds of whiskeys and a killer jukebox.',
    attributes: {
      poolTable: false,
      darts: false,
      cashOnly: false,
      jukebox: true,
      outdoorSeating: false,
      liveMusic: true,
      happyHour: false
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_5',
    name: 'The Mutiny',
    address: '2428 N Western Ave',
    neighborhood: 'Logan Square',
    lat: 41.9271,
    lng: -87.6875,
    description: 'Pirate-themed dive with strong drinks and an unpretentious vibe.',
    attributes: {
      poolTable: true,
      darts: true,
      cashOnly: false,
      jukebox: true,
      outdoorSeating: false,
      liveMusic: false,
      happyHour: true
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_6',
    name: 'Rainbo Club',
    address: '1150 N Damen Ave',
    neighborhood: 'Ukrainian Village',
    lat: 41.9025,
    lng: -87.6773,
    description: 'Hipster dive with a photo booth and cheap PBR. Instagram before Instagram.',
    attributes: {
      poolTable: false,
      darts: false,
      cashOnly: false,
      jukebox: true,
      outdoorSeating: false,
      liveMusic: false,
      happyHour: true
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_7',
    name: 'The Long Room',
    address: '1612 W Irving Park Rd',
    neighborhood: 'Lakeview',
    lat: 41.9544,
    lng: -87.6694,
    description: 'Narrow neighborhood bar with board games and a relaxed atmosphere.',
    attributes: {
      poolTable: false,
      darts: true,
      cashOnly: false,
      jukebox: true,
      outdoorSeating: true,
      liveMusic: false,
      happyHour: true
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_8',
    name: "L&L Tavern",
    address: '3207 N Clark St',
    neighborhood: 'Lakeview',
    lat: 41.9407,
    lng: -87.6539,
    description: 'Classic Wrigleyville dive. Cheap shots and Cubs fans since forever.',
    attributes: {
      poolTable: false,
      darts: true,
      cashOnly: true,
      jukebox: true,
      outdoorSeating: false,
      liveMusic: false,
      happyHour: true
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_9',
    name: 'The Owl',
    address: '2521 N Milwaukee Ave',
    neighborhood: 'Logan Square',
    lat: 41.9275,
    lng: -87.7019,
    description: 'Night owl paradise. Dark, cheap, and open until 4am.',
    attributes: {
      poolTable: true,
      darts: true,
      cashOnly: false,
      jukebox: true,
      outdoorSeating: false,
      liveMusic: false,
      happyHour: false
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_10',
    name: 'Archie\'s Iowa Rockwell Tavern',
    address: '2600 S Archer Ave',
    neighborhood: 'Bridgeport',
    lat: 41.8433,
    lng: -87.6875,
    description: 'Old-school Bridgeport bar. Cheap drinks, pool, and no nonsense.',
    attributes: {
      poolTable: true,
      darts: true,
      cashOnly: true,
      jukebox: true,
      outdoorSeating: false,
      liveMusic: false,
      happyHour: false
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_11',
    name: 'Skylark',
    address: '2149 S Halsted St',
    neighborhood: 'Pilsen',
    lat: 41.8537,
    lng: -87.6464,
    description: 'Pilsen institution with craft cocktails at dive bar prices.',
    attributes: {
      poolTable: false,
      darts: false,
      cashOnly: false,
      jukebox: true,
      outdoorSeating: true,
      liveMusic: true,
      happyHour: true
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_12',
    name: 'Innertown Pub',
    address: '1935 W Thomas St',
    neighborhood: 'Ukrainian Village',
    lat: 41.9016,
    lng: -87.6782,
    description: 'Cozy corner bar with cheap drinks and friendly regulars.',
    attributes: {
      poolTable: true,
      darts: true,
      cashOnly: false,
      jukebox: true,
      outdoorSeating: true,
      liveMusic: false,
      happyHour: true
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_13',
    name: 'Gold Star Bar',
    address: '1755 W Division St',
    neighborhood: 'Wicker Park',
    lat: 41.9030,
    lng: -87.6722,
    description: 'Wicker Park dive with punk rock roots and killer DJs.',
    attributes: {
      poolTable: false,
      darts: false,
      cashOnly: false,
      jukebox: true,
      outdoorSeating: false,
      liveMusic: true,
      happyHour: true
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_14',
    name: "Nick's Beer Garden",
    address: '1516 N Milwaukee Ave',
    neighborhood: 'Wicker Park',
    lat: 41.9088,
    lng: -87.6746,
    description: 'Hidden gem with a massive back patio. Neighborhood favorite.',
    attributes: {
      poolTable: true,
      darts: true,
      cashOnly: false,
      jukebox: true,
      outdoorSeating: true,
      liveMusic: false,
      happyHour: true
    },
    createdAt: Date.now()
  },
  {
    id: 'bar_15',
    name: 'Weeds Tavern',
    address: '1555 N Dayton St',
    neighborhood: 'Old Town',
    lat: 41.9105,
    lng: -87.6428,
    description: 'Poetry readings, cheap beer, and eccentric charm.',
    attributes: {
      poolTable: false,
      darts: false,
      cashOnly: true,
      jukebox: false,
      outdoorSeating: true,
      liveMusic: true,
      happyHour: false
    },
    createdAt: Date.now()
  }
];

// Generate seed ratings
export const generateSeedRatings = () => {
  const ratings = [];
  const userNames = ['DiveDan', 'BarHopper', 'ChicagoCrawl', 'NightOwl', 'PBRPete', 'WhiskeyWanda'];
  
  SEED_BARS.forEach(bar => {
    // Generate 3-6 ratings per bar
    const numRatings = Math.floor(Math.random() * 4) + 3;
    
    for (let i = 0; i < numRatings; i++) {
      ratings.push({
        id: `rating_${bar.id}_${i}`,
        barId: bar.id,
        userId: `user_seed_${i % userNames.length}`,
        userName: userNames[i % userNames.length],
        overall: Math.floor(Math.random() * 2) + 3.5 + Math.random(),
        price: Math.floor(Math.random() * 2) + 4,
        ambiance: Math.floor(Math.random() * 2) + 3,
        crowd: Math.floor(Math.random() * 3) + 3,
        service: Math.floor(Math.random() * 2) + 3,
        isDiveBar: Math.random() > 0.2, // 80% vote yes
        createdAt: Date.now() - Math.floor(Math.random() * 30 * 24 * 60 * 60 * 1000)
      });
    }
  });
  
  return ratings;
};

// Generate seed comments
export const generateSeedComments = () => {
  const comments = [];
  const sampleComments = [
    "Perfect spot for a cheap drink after work.",
    "The jukebox selection is unmatched. Old school vibes.",
    "Bartender knows everyone's name. True neighborhood spot.",
    "Cash only keeps the riff-raff out. Love it.",
    "Best dive in the city. Don't tell anyone.",
    "Sticky floors, cold beer, what more do you need?",
    "Been coming here for 20 years. Never changes.",
    "The regulars are characters. Great people watching.",
    "Cheapest shots in Chicago. Period.",
    "This is what a bar should be."
  ];
  
  SEED_BARS.slice(0, 8).forEach((bar, idx) => {
    comments.push({
      id: `comment_${bar.id}_1`,
      barId: bar.id,
      userId: 'user_seed_0',
      userName: 'DiveDan',
      text: sampleComments[idx % sampleComments.length],
      createdAt: Date.now() - Math.floor(Math.random() * 7 * 24 * 60 * 60 * 1000)
    });
  });
  
  return comments;
};

// Seed users for social features
export const SEED_USERS = [
  { id: 'user_seed_0', username: 'DiveDan', displayName: 'Dive Dan', joinedAt: Date.now() - 90 * 24 * 60 * 60 * 1000 },
  { id: 'user_seed_1', username: 'BarHopper', displayName: 'Bar Hopper', joinedAt: Date.now() - 60 * 24 * 60 * 60 * 1000 },
  { id: 'user_seed_2', username: 'ChicagoCrawl', displayName: 'Chicago Crawler', joinedAt: Date.now() - 45 * 24 * 60 * 60 * 1000 },
  { id: 'user_seed_3', username: 'NightOwl', displayName: 'Night Owl', joinedAt: Date.now() - 30 * 24 * 60 * 60 * 1000 },
  { id: 'user_seed_4', username: 'PBRPete', displayName: 'PBR Pete', joinedAt: Date.now() - 20 * 24 * 60 * 60 * 1000 },
  { id: 'user_seed_5', username: 'WhiskeyWanda', displayName: 'Whiskey Wanda', joinedAt: Date.now() - 10 * 24 * 60 * 60 * 1000 }
];

